import { PolymorphicComponentPropWithRef } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type TableComponentProps = {};

export type TableProps<T extends React.ElementType> =
    PolymorphicComponentPropWithRef<T, TableComponentProps, "table">;

const Table = <T extends React.ElementType = "table">({
    ref,
    className,
    tag,
    children,
    ...attributes
}: TableProps<T>) => {
    const Tag = tag || ("table" as React.ElementType);
    const classes = cn("tw:border-collapse tw:w-full tw:mb-4", className);

    const table = (
        <Tag
            {...attributes}
            ref={ref}
            className={classes}
        >
            {children}
        </Tag>
    );

    return table;
};

export { Table };
